/** @format */

// HEADERS
export const CSV_HEADER = 'id,label,UserId,public,lat,lng,alt,model,serial,firmware,subnet,GatewayProfileId,supportsRemoteControl,rctrlUsername,rctrlPassword'.split(',');